<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form :inline="true" ref="form" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit"
                >搜索
                </el-button
                >
              </div>
              <div class="uers-right">
                <span>
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出
                </el-button
                >
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                </span>
                &nbsp;
                <el-popover
                    placement="bottom"
                    title="批量导入"
                    width="220"
                    trigger="click"
                >
                  <div>
                    <el-upload
                        class="upload-demo"
                        :auto-upload="false"
                        :on-change="uploadChange"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                      <el-button size="small" type="primary"
                      >选择导入模板
                      </el-button
                      >
                    </el-upload>
                    <el-button
                        type="success"
                        @click="download"
                        plain
                        icon="el-icon-download"
                        class="down-template"
                    >下载模板
                    </el-button
                    >
                  </div>
                  <p class="import-text">只能选择 .xls .xlsx 文件</p>
                  <div>
                    <el-button type="success" @click="importData"
                    >新增
                    </el-button
                    >
                  </div>
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-upload2"
                      slot="reference"
                  >导入
                  </el-button
                  >
                </el-popover>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="table"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column prop="documentTypeId" label="ID" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.documentTypeId }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="checkIn" label="限制次数" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.checkIn }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="url" label="图片" align="center">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.url"
                        :preview-src-list="[scope.row.url]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="startDate" label="开始日期" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.startDate }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="endDate" label="结束日期" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.endDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      @click="handleCopy(scope.$index, scope.row)"
                  >复制
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditTypeManage
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditTypeManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditTypeManage from "../../../components/ticketing/certificate/EditTypeManage";
import DeleteDialog from "../../../components/public/DeleteConfim";
import XLSX from "xlsx";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      totalPage: 0,
      dataList: [],
      arrayList: [],
      multipleSelection: [],
      listShow: true,
      delVisible: false,
      editShow: false,
      editData: {},
      searchForm: {
        name: "",
      },
      documentType_Id: "",
      projectId: localStorage.getItem("project_Id"),
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    download() {
      let url = localStorage.getItem("url");
      window.open(url.replace("/api", "/") + "/data/证件类型模板.xlsx");
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          let codes = [];
          outdata.map((v) => {
            let obj = {};
            obj.documentTypeId = v.ID;
            obj.name = v.类型名称;
            obj.projectId = v.项目ID;
            obj.rule = v.规则;
            obj.checkIn = v.进入次数;
            obj.url = v.图片;
            obj.width = v.宽度;
            obj.height = v.高度;
            obj.qrcodeX = v.X坐标;
            obj.price = v.价格;
            obj.qrcodeY = v.Y坐标;
            obj.qrcodeSize = v.大小;
            obj.startDate = v.开始日期;
            obj.endDate = v.结束日期;
            obj.effectiveDate = v.有效时间;
            obj.hit = v.分论坛权限;
            obj.faceMatchScore = v.比较值;
            obj.faceMatch = v.人脸比较;
            ar.push(obj);
          });
          localStorage.setItem("attr", JSON.stringify(ar));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    importData() {
      this.attr = JSON.parse(localStorage.getItem("attr"));
      if (this.attr && this.attr.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let url = "/DocumentType/AddList/" + this.projectId;
        this.$axios
            .put(url, this.attr)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                localStorage.setItem("attr", null);
                this.getData();
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }
    },
    handleCopy(index, row) {
      if (confirm("是否拷贝行")) {
        let data = JSON.parse(JSON.stringify(row));
        data.documentTypeId = null;
        data.name += "-拷贝"
        this.$axios.post(`/DocumentType/`, data).then((res) => {
          if (res.data.hasError) {
            this.$message.error(res.data.message);
          } else {
            this.$message.success("新增成功！");
            this.getData();
          }
        });
      }
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    addSubmit() {
      this.documentType_Id = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    exportExcel() {
      var search = {
        name: this.searchForm.name,
        projectId: this.projectId,
        pageIndex: this.currentPage - 1,
        pageSize: 100000,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/DocumentType/Export`, search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
              window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出失败");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出失败");
          });
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        projectId: this.projectId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
      };
      this.$axios.post("/DocumentType/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    deleteData() {
      this.$axios
          .delete(`/DocumentType/${this.documentType_Id}`)
          .then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("删除成功！");
              this.delVisible = false;
              this.getData();
            }
          });
    },
    handleCloseVisible() {
      this.delVisible = false;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.documentType_Id = row.documentTypeId;
      this.delVisible = true;
    },
  },
  components: {
    EditTypeManage,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.el-main {
  border-radius: 5px;
  position: relative;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin-bottom: 20px;

  .btn-r {
    margin-right: 20px;
  }
}

.pag {
  position: absolute;
  bottom: 0;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}

.el-dialog {
  height: auto;
}
</style>